module.exports = __webpack_public_path__ + "static/lettuce-14cf7c226ad0cc756442162d49661939.png";